import { render, staticRenderFns } from "./WallAccommodationsBlockSettings.vue?vue&type=template&id=47a3d2f7"
import script from "./WallAccommodationsBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallAccommodationsBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports